import React from "react";
import logo from "../assets/Images/Visko_logo.png";
import { HashLink } from "react-router-hash-link";
const Footer = () => {
  return (
    <div>
      <footer id="footer" class="footer dark-background">
        <div class="footer-top">
          <div class="container">
            <div class="row gy-4">
              <div class="col-lg-4 col-md-6 footer-about mx-auto text-center">
                <a
                  href="index.html"
                  class="logo d-flex justify-content-center align-items-center"
                >
                  <span class="sitename">
                    <img
                      class="img-fluid"
                      src={logo}
                      style={{ height: "2000px" }}
                      alt="Logo"
                    />
                  </span>
                </a>
                <p>
                  The Visko Group stands as a pinnacle of innovation and
                  enterprise, housing four remarkable projects that collectively
                  redefine industries and bring forth positive change.
                </p>
              </div>
              {/* <div class="row-lg-2 row-md-3 footer-links ml-auto text-md-right text-center">
                <h4>Quick Links</h4>
                <div class="text-center" style={{ display: "flex" }}>
                  <ul class="d-flex justify-content-between gap-4 text-center">
                    <li>
                      <a href="#home">Home</a>
                    </li>
                    <li>
                      <a href="#about">About</a>
                    </li>
                    <li>
                      <a href="#Services">Services</a>
                    </li>
                    <li>
                      <a href="#ourproject">Our Project</a>
                    </li>
                    <li>
                      <a href="#contact">Contact</a>
                    </li>
                  </ul>
                </div>
              </div> */}

              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-12 text-center">
                    <h4>Quick Links</h4>
                    <div className="d-flex justify-content-center">
                      <ul className="d-flex justify-content-center gap-4 list-unstyled">
                        <li>
                          <HashLink smooth to="/#home">Home</HashLink>
                        </li>
                        <li>
                          <HashLink smooth to="/#about">About</HashLink>
                        </li>
                        <li>
                          <HashLink smooth to="/#services">Our Companies</HashLink>
                        </li>
                       
                        <li>
                          <HashLink smooth to="/#contact">Contact</HashLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="copyright text-center">
          <div class="container d-flex flex-column flex-lg-row justify-content-center justify-content-lg-between align-items-center">
            <div class="d-flex flex-column align-items-center align-items-lg-start">
              <div>
                © Copyright{" "}
                <strong>
                  <span>Visko Group</span>
                </strong>
                . All Rights Reserved
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
